import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageComponent } from './landing-page.component';
import { SharedModule } from '../shared/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { NdgInsertModule } from './ndg-insert/ndg-insert.module';
import { AppRoutingModule } from '../app-routing.module';
import { SurveyModule } from './survey/survey.module';

@NgModule({
  declarations: [
    LandingPageComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FontAwesomeModule,
    AppRoutingModule,

    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,

    NdgInsertModule,
    SurveyModule
  ]
})
export class LandingPageModule {}
